import { PageNotFoundError } from 'src/utils/error'
import { ErrorPage } from '../ErrorPage'

export const NotFound = () => {
  return <ErrorPage exception={new PageNotFoundError('page not found')} />
}
